import {Routes} from '@angular/router';

import {HebergementBnbaccessComponent} from './hebergement-bnbaccess.component';
import {HebergementBnbaccessDetailComponent} from './hebergement-bnbaccess-detail.component';
import {HebergementBnbaccessDialogComponent} from './hebergement-bnbaccess-dialog.component';
import {HebergementBnbaccessDeletePopupComponent} from './hebergement-bnbaccess-delete-dialog.component';
import {DroitPopupComponent} from './droit/droit.component';


export const hebergementRoute: Routes = [
    {
        path: 'hebergement-bnbaccess',
        component: HebergementBnbaccessComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.hebergement.home.title'
        }
    }, {
        path: 'hebergement-bnbaccess/:id',
        component: HebergementBnbaccessDetailComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.hebergement.home.title'
        }
    },
    {
        path: 'hebergement-bnbaccess/:id/edit',
        component: HebergementBnbaccessDialogComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.hebergement.home.title'
        }
    },
    {
        path: 'hebergement-bnbaccess-new',
        component: HebergementBnbaccessDialogComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.hebergement.home.title'
        }
    }
];

export const hebergementPopupRoute: Routes = [
    {
        path: 'hebergement-bnbaccess/:id/delete',
        component: HebergementBnbaccessDeletePopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.hebergement.home.title'
        },
        outlet: 'popup'
    },
    {
        path: 'hebergement-bnbaccess/:id/edit-droit',
        component: DroitPopupComponent,
        data: {
            authorities: ['ROLE_USER'],
            pageTitle: 'bnbaccessBoApp.hebergement.droit.title'
        },
        outlet: 'popup'
    },
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/hebergement/hebergement-bnbaccess.route.ts